import { H2 } from "../ui";
import { twMerge } from "tailwind-merge";

type InfoCardProps = {
    title: string;
    text: string;
    icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
    className?: string;
};

export const InfoCard: React.FC<InfoCardProps> = ({ title, text, icon: Icon, className }) => {
    return (
        <div
            className={twMerge("rounded-md border border-ochre_accent max-w-72 h-auto hover:scale-105", className)}>
            <div className="flex h-full p-2">
                <div>
                    {Icon && (
                        <Icon className="size-16 stroke-current text-dark_secondary dark:text-light_primary" />
                    )}
                </div>
                <div className="flex flex-col gap-3 p-3 ">
                    <div>
                        <H2 className="hover:font-semibold">{title}</H2>
                    </div>
                    <div className="flex flex-col h-full justify-center">
                        <p>{text}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

